import { Box, Text } from "@chakra-ui/react"
import { useNavigate } from "react-router-dom"



export const GamePage = () =>{
const navigate = useNavigate()


return (
    <Box>
        <Text border={'1px solid red'} p={'20px'} m={'10px'} onClick={()=>navigate('TicTacToe')}>TicTacToe</Text>
        <Text border={'1px solid red'} p={'20px'} m={'10px'} onClick={()=>navigate('Doodle-Jump')}>Doodle Jump</Text>

    </Box>
)
}